import { alpha } from "@mui/material/styles";

// ----------------------------------------------------------------------

export default function Autocomplete(theme) {
  return {
    MuiAutocomplete: {
      styleOverrides: {
        paper: {
          boxShadow: theme.customShadows.z20,
          backgroundColor: theme.palette.background.paper,
          border: `1px solid ${theme.palette.divider}`,
        },
        listbox: {
          backgroundColor: theme.palette.background.paper,
          "& .MuiAutocomplete-option": {
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.text.primary,
            "&:hover": {
              backgroundColor: theme.palette.action.hover,
            },
            '&[aria-selected="true"]': {
              backgroundColor: theme.palette.action.selected,
              "&:hover": {
                backgroundColor: alpha(theme.palette.action.selected, 1),
              },
            },
            "&.Mui-focused": {
              backgroundColor: theme.palette.action.hover,
            },
          },
        },
        option: {
          backgroundColor: theme.palette.background.paper,
          color: theme.palette.text.primary,
          "&:hover": {
            backgroundColor: theme.palette.action.hover,
          },
          '&[aria-selected="true"]': {
            backgroundColor: theme.palette.action.selected,
            "&:hover": {
              backgroundColor: alpha(theme.palette.action.selected, 1),
            },
          },
          "&.Mui-focused": {
            backgroundColor: theme.palette.action.hover,
          },
        },
      },
    },
  };
}
